/**
 * Small conversions the quant panels need, kept out of the components so they can be tested.
 *
 * <p>There is one of them so far and it is three lines, which is exactly the kind of code that
 * ships wrong: a half-typed number in a text box becomes `NaN`, `NaN` becomes `returnTarget=NaN`
 * in a query string, and the request fails in a way that looks like the optimiser refusing.
 */

/** Trading days in a year. Log returns add, so an annual figure divides straight down. */
export const TRADING_DAYS = 252

/**
 * A return floor typed as a percent a year, as the mean daily log return the wire expects.
 *
 * <p>People think about returns in percent a year and the optimiser's window is made of daily
 * log returns, so something has to convert - and the conversion is a division rather than a
 * compounding precisely because they are log returns.
 *
 * @return undefined when the box is empty or holds something that is not yet a number, which is
 *         every intermediate state of typing "-2.5" and must mean "no floor asked for" rather
 *         than a floor of NaN.
 */
export function annualFloorToDaily(input: string): number | undefined {
  const trimmed = input.trim()
  if (trimmed === '') return undefined
  const percent = Number(trimmed)
  if (!Number.isFinite(percent)) return undefined
  return percent / 100 / TRADING_DAYS
}
